import axios from '@/utils/axiosReq'
import URL from './urlConstants'
class CommonFetch {
  // 权限校验接口
  getLoggingValid (params) {
    return axios.get(URL.COMMON.LOGGING_VALID, params)
  }
  // 用户信息
  queryUserInfo (params) {
    return axios.get(URL.COMMON.USER_INFO, params)
  }
  // 获取用户导航信息
  getUserMenu (params) {
    return axios.get(URL.COMMON.USER_MENU, params)
  }
  // 获取左侧菜单
  getSliderMenu (params) {
    return axios.get(URL.COMMON.SLIDER_MENU, params)
  }
  // 版本号
  getVersions (params) {
    return axios.get(URL.COMMON.VERSIONS, params)
  }
  // 获取商家查询信息
  getSellerList (params) {
    return axios.get(URL.COMMON.SELLER_LIST, params)
  }
  // 事业部
  getDept (params) {
    return axios.get(URL.COMMON.DEPT, params)
  }
  // 获取租户未读取的消息数
  getUnReadCount () {
    return axios.get(URL.COMMON.UN_READ_COUNT)
  }
  // 获取用户消息数量
  getMessageList (params) {
    return axios.get(URL.COMMON.MSG_LIST, params)
  }
  // 读取当前消息
  readMessage (params) {
    return axios.post(URL.COMMON.READ_MSG, params)
  }
  // 未读消息全部标记为已读
  readAllMessage () {
    return axios.post(URL.COMMON.READ_All_MSG)
  }
  // 退出登录
  logout (params) {
    return axios.get(URL.COMMON.USER_LOGOUT, params)
  }
}
const commonFetch = new CommonFetch()
export default commonFetch
